module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"nav":["Inicio ","Módulos","Industrias","Cómo Funciona","Alianzas","Quiénes somos","Destacados"]},"en":{"nav":["Home","Modules","Industries","How it works","Alliances","About us","Highlights"]},"pt":{"nav":["Inicio","Módulos","Indústrias","Como funciona","Alianças","Quem somos","Destaque"]}}')
  delete Component.options._Ctor
}
